import { SCH4U } from "../../data/OSSD/Grade12/SCH4U";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function SCH4UPage() {
    return (
        <div>
            <GradeCourseTemplate data={SCH4U} />
        </div>
    )
}